import React, { useEffect, useImperativeHandle, useState } from 'react'
import { deleteData, getData, postData, putData } from '../../services/Axios/Axios';
import { ApiUrl } from '../../config/apiConfig';
import { useLoader } from '../../components/loader/loader';
import { confirmAction, formatDate } from '../../utils/utils';
import messageService from '../../services/message/messageService';
import { CRM_ACCESS, Employee } from '../../models/Employee';
import { sendAccountStatusChangeMail } from '../../functions/accountFunctions';
import { createAdminUserByEmployee } from '../../utils/user-utils';

interface UserTableProps {
  addEditModel: (data?: any) => void
  getAllData: () => void

}
const AcUserRequestTable = React.forwardRef((props: UserTableProps, ref) => {
  const { show, hide } = useLoader();
  const [copied, setCopied] = useState(false);
  const [allUsers, setAllUsers] = useState<any>([]);
  const [team, setTeam] = useState<Employee[]>([]);


  const handleCopy = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
      alert("Copied to clipboard!");
      setCopied(true);
      setTimeout(() => setCopied(false), 2000); // hide after 2 seconds
    });

  };





  const getAllTeam = async () => {
    const response = await getData(ApiUrl.getHiredTeams, {}, {
      show,
      hide,
    });

    if (response.data) {
      setTeam(response.data.filter((obj: Employee) => (obj?.teamStatus == "In Progress" && obj?.crmAccess == CRM_ACCESS.PENDING)))
    }
  }


  useEffect(() => {
    getAllTeam()
  }, []);





  const createNewUser = async (candidate: Employee) => {
    try {
      const obj = createAdminUserByEmployee(candidate);

      await Promise.all([
        postData(ApiUrl.createAdmin, obj),
        putData(`${ApiUrl.updateTeam}${candidate._id}`, {
          crmAccess: CRM_ACCESS.APPROVE
        })
      ]);

      sendAccountStatusChangeMail(
        obj.email,
        obj.name,
        "CONFIRMED",
        obj.password
      );

      props?.getAllData();
      setTeam((prev) => (prev.filter((c) => c._id !== candidate._id)))
      messageService().toast(
        "success",
        `User created successfully`
      );
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <div className="w-full overflow-x-auto px-2">
      <table className="min-w-full border-collapse border border-gray-100  overflow-hidden shadow text-center">
        <thead className="whitespace-nowrap">
          <tr className="bg-greenBg text-white whitespace-nowrap">
            <th className="border border-gray-200 p-2">
              S no
            </th>

            <th className="border border-gray-200 p-2">User Name</th>
            <th className="border border-gray-200 p-2">User Type</th>
            <th className="border border-gray-200 p-2">Email Address</th>
            <th className="border border-gray-200 p-2">Phone Number</th>
            <th className="border border-gray-200 p-2">
              Assigned Permissions
            </th>
            <th className="border border-gray-200 p-2">Created At</th>

            <th className="border border-gray-200 p-2">Action</th>
          </tr>
        </thead>
        <tbody className="border border-gray-400 whitespace-nowrap ">

          {/* team requests list */}
          {team.map((user: Employee, index: number) => <tr key={index} className=" hover:bg-[#f0f0f0] border border-collapse text-[13px]" >
            <td className="px-2 border border-gray-200">{user.employeeId}</td>
            <td className="px-2 border border-gray-200">{user.firstName} {user.lastName}</td>
            <td className="px-2 border border-gray-200">N/A</td>
            <td className="px-2 border border-gray-200">{user.email}</td>
            <td className="px-2 border border-gray-200">{user.phone ? user.phone : "--"}</td>
            <td className="px-2 border border-gray-200">0 Permissions</td>
            <td className="px-2 border border-gray-200">{formatDate(user.createdAt)}</td>
            <td className="px-2 border border-gray-200">
              <div className="flex justify-center items-center gap-2 py-1">
                <button onClick={() => {
                  confirmAction("you want to create user", () => createNewUser(user))
                }} className='bg-greenBg hover:bg-customOrange text-[10px] text-white px-2 p-[2px] rounded-md'>
                  Add
                </button>
              </div>
            </td>
          </tr>)}
          {team.length === 0 && <td className='py-[4rem]' colSpan={9}>No account request found</td>}

        </tbody>
      </table>
    </div>
  )
})

export default AcUserRequestTable

